import styled from 'styled-components'

import { theme } from '../../constants'

export const PageShell = styled.div`
  width: 100%;
  min-height: 100%;
  padding: ${theme.spacing[8]} ${theme.layout.contentGutter};
  box-sizing: border-box;
  color: ${theme.colors.textPrimary};
  background: ${theme.colors.background};
  font-family: ${theme.typography.family};

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding-top: ${theme.spacing[6]};
    padding-bottom: ${theme.spacing[6]};
  }
`

export const PageContent = styled.div`
  width: 100%;
  max-width: ${theme.layout.contentMaxWidth};
  margin: 0 auto;
`
